import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components
import Panel from "../../../../components/panel/panel";
import Select from "../../../../components/input/Select";
//services
import { getReportSped } from "../../../../services/Report/getReportSped";

const FilterSped = ({
  onFilter,
  setShowTable,
  ownersOptions,
  loadingOwners,
}) => {
  const form = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const date_sped = new Date(data.date_sped);
      const [month, year] = [date_sped.getMonth() + 1, date_sped.getFullYear()];

      const filters = {
        owner_id: data.owner_id,
        year: year.toString(),
        month: month.toString(),
        installment_description_id: data.parcel_description_id,
      };

      const result = await getReportSped(filters);
      setShowTable(true);
      if (onFilter) onFilter(result);
    } catch (error) {
      toast.error("Erro ao buscar relatórios SPED.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Panel title="Filtrar relatório SPED" className="p-4">
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row pt-2">
          <div className="col-md-4">
            <Select
              name="owner_id"
              label="Proprietário *"
              control={form.control}
              errors={form.formState.errors}
              options={ownersOptions}
              isRequired
              optionLabel="label"
              optionValue="value"
              placeholder={
                loadingOwners ? "Carregando..." : "Selecione o proprietário"
              }
            />
          </div>
          <div className="col-md-2 pt-1">
            <Button
              type="submit"
              icon="fa fa-search"
              loading={loading}
              aria-label="Search"
              className="mt-3 w-100"
            />
          </div>
        </div>
      </form>
    </Panel>
  );
};

export default FilterSped;
